import { Component } from '@angular/core';
import { MasterBodypartsComponent } from './master-bodyparts/master-bodyparts.component';
import { MasterImplantsComponent } from './master-implants/master-implants.component';
import { MasterCategoriesComponent } from './master-categories/master-categories.component';
import { MasterProductsComponent } from './master-products/master-products.component';

@Component({
  selector: 'app-master-data',
  standalone: true,
  imports: [MasterBodypartsComponent, MasterImplantsComponent, MasterCategoriesComponent, MasterProductsComponent],
  templateUrl: './master-data.component.html',
  styleUrls: ['./master-data.component.scss', '../../app.component.scss']
})
export class MasterDataComponent {

}
